const state = {
    statuses: [],
    criteria_builder_columns: {},
}

export default state;
